import { Step1Content, Step2Content, Step3Content, Step4Content } from "./StepContents";
// Used as the prefix to identify components on the tenant setup tour
export var TENANT_SETUP_TOUR_PREFIX = "tenantSetupTour";
var steps = [
    {
        target: "[data-tour=\"" + TENANT_SETUP_TOUR_PREFIX + "step01\"]",
        Content: Step1Content,
        placement: "auto",
        disableBeacon: true // Start tour straight away
    },
    {
        target: "[data-tour=\"" + TENANT_SETUP_TOUR_PREFIX + "step02\"]",
        Content: Step2Content,
        placement: "auto"
    },
    {
        target: "[data-tour=\"" + TENANT_SETUP_TOUR_PREFIX + "step03\"]",
        Content: Step3Content,
        placement: "right"
    },
    {
        target: "[data-tour=\"" + TENANT_SETUP_TOUR_PREFIX + "step04\"]",
        Content: Step4Content,
        placement: "auto"
    }
];
export default steps;
